import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsDamageAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const documentTypeArray = ['EGD018', 'EGD020','EGD022', 'EGD030',  'EGD031', 'EGD033'];

	return !!documentType && (!coverProcessId && !foreignCustomerId) && documentCategory ===  "EGD06"
	          && !documentTypeArray.includes(documentType) ? { checkDocCategoryIsDamageAndDocTypeAllowedFlag: true } : null;
};
